import { useEnvContext } from "context/EnvContext";
import { TRACK_EVENTS } from "core/consts";
import { IsSealdOnly } from "core/types";
import { useCallback } from "react";
import { useTracking } from "react-tracking";
import {
  useLoggedCareproviderConfig,
  useLoggedCareseekerConfig,
} from "reduxentities/hooks";

export function useIsLoggedSealdOnly(): IsSealdOnly {
  const { app } = useEnvContext();
  const { trackEvent } = useTracking();

  const loggedCareseekerWithSealdOnlyEncryption = useLoggedCareseekerConfig(
    "seald_only_encryption",
  );

  const loggedCareproviderWithSealdOnlyEncryption = useLoggedCareproviderConfig(
    "seald_only_encryption",
  );

  return useCallback(
    (sessionsInContext) => {
      if (
        Boolean(sessionsInContext?.oldSession) &&
        !sessionsInContext?.newSealdSession
      ) {
        // when there are already sessions in context (i.e. we're not creating a new session)
        // if only the old encryption exists, still allow the user to use it
        // this is to prevent users recently fixed to not loose encrypted data access
        //  we should delete this soon [now=Jun2024]
        trackEvent({ name: TRACK_EVENTS.SEALD_ONLY_FALLBACK_TRIGGERED });
        return false;
      }

      return Boolean(
        loggedCareseekerWithSealdOnlyEncryption ||
          loggedCareproviderWithSealdOnlyEncryption,
      );
    },
    [
      trackEvent,
      app,
      loggedCareseekerWithSealdOnlyEncryption,
      loggedCareproviderWithSealdOnlyEncryption,
    ],
  );
}
